
import { atom } from 'jotai';

const textSelectionAtom = atom();

export { textSelectionAtom };